// extracted by mini-css-extract-plugin
export default {"menuBlock":"zF-z","title":"AF-z","nav":"BF-z","flexCell":"CF-z","facetLink":"DF-z"};